document.addEventListener('DOMContentLoaded', function () {
	// Desktop menu: the arrow is a separate button so Enter on the link
	// itself always follows the link, while Enter/Space on the arrow
	// opens or closes the sub-menu without leaving the page.
	const siteMenuToggles = document.querySelectorAll('.site-menu > .menu-item-has-children > .submenu-toggle');

	function closeToggle(toggle) {
		const menuItem = toggle.closest('.menu-item-has-children');
		if (menuItem) menuItem.classList.remove('submenu-open');
		toggle.setAttribute('aria-expanded', 'false');
	}

	function openToggle(toggle) {
		siteMenuToggles.forEach(closeToggle);
		const menuItem = toggle.closest('.menu-item-has-children');
		if (menuItem) menuItem.classList.add('submenu-open');
		toggle.setAttribute('aria-expanded', 'true');
	}

	siteMenuToggles.forEach(function (toggle) {
		// Suppress the focus-visible outline for mouse users without
		// actually moving focus (a real .blur() would fire the
		// "focusout" handler below and immediately re-close the
		// sub-menu it just opened). Keyboard activation never fires
		// mousedown, so :focus-visible still shows for that case.
		toggle.addEventListener('mousedown', function () {
			toggle.classList.add('mouse-focus');
		});
		toggle.addEventListener('blur', function () {
			toggle.classList.remove('mouse-focus');
		});

		toggle.addEventListener('click', function () {
			const isOpen = toggle.getAttribute('aria-expanded') === 'true';
			if (isOpen) {
				closeToggle(toggle);
			} else {
				openToggle(toggle);
			}
		});

	});

	// Close an open sub-menu when focus leaves that menu-item entirely.
	document.querySelectorAll('.site-menu > .menu-item-has-children').forEach(function (menuItem) {
		menuItem.addEventListener('focusout', function (e) {
			if (!menuItem.contains(e.relatedTarget)) {
				const toggle = menuItem.querySelector(':scope > .submenu-toggle');
				if (toggle) closeToggle(toggle);
			}
		});

		// A keyboard-opened sub-menu stays open (via the "submenu-open"
		// class) even after the mouse moves elsewhere, since nothing
		// mouse-related closes it. Without this, hovering a different
		// top-level item shows that one via :hover while the keyboard
		// item stays open too, and both fixed-position sub-menus overlap.
		menuItem.addEventListener('mouseenter', function () {
			siteMenuToggles.forEach(function (toggle) {
				if (toggle.closest('.menu-item-has-children') !== menuItem) {
					closeToggle(toggle);
				}
			});
		});
	});

	// Escape closes whichever sub-menu is open, no matter where focus is
	// inside it, and returns focus to that item's toggle button.
	document.addEventListener('keydown', function (e) {
		if (e.key !== 'Escape') return;
		siteMenuToggles.forEach(function (toggle) {
			if (toggle.getAttribute('aria-expanded') === 'true') {
				const menuItem = toggle.closest('.menu-item-has-children');
				if (menuItem && menuItem.contains(document.activeElement)) {
					closeToggle(toggle);
					toggle.focus();
				}
			}
		});
	});

	// Topline language switcher (weglot-parent-menu-item) — its own link
	// has no real destination (href="#weglot_switcher"), so Enter/click
	// on the link itself opens its language sub-menu.
	document.querySelectorAll('.menu-topline .weglot-parent-menu-item').forEach(function (menuItem) {
		const link = menuItem.querySelector(':scope > a');
		if (!link) return;

		link.setAttribute('aria-expanded', 'false');

		function closeLangMenu() {
			menuItem.classList.remove('submenu-open');
			link.setAttribute('aria-expanded', 'false');
		}

		function openLangMenu() {
			document.querySelectorAll('.menu-topline .weglot-parent-menu-item').forEach(function (other) {
				if (other !== menuItem) {
					other.classList.remove('submenu-open');
					const otherLink = other.querySelector(':scope > a');
					if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
				}
			});
			menuItem.classList.add('submenu-open');
			link.setAttribute('aria-expanded', 'true');
		}

		link.addEventListener('click', function (e) {
			e.preventDefault();
			if (link.getAttribute('aria-expanded') === 'true') {
				closeLangMenu();
			} else {
				openLangMenu();
			}
		});

		menuItem.addEventListener('focusout', function (e) {
			if (!menuItem.contains(e.relatedTarget)) {
				closeLangMenu();
			}
		});

		menuItem.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && link.getAttribute('aria-expanded') === 'true') {
				closeLangMenu();
				link.focus();
			}
		});
	});

	document.querySelectorAll('.sub-menu').forEach(function (subMenu) {
		const overviewList = subMenu.querySelector('.overview-list');
		if (!overviewList) return;

		function activateL2Item(l2Item) {
			const target = l2Item.dataset.target;

			subMenu.querySelectorAll('.l2-item').forEach(el => el.classList.remove('active'));
			subMenu.querySelectorAll('.rest-group').forEach(el => el.classList.remove('active'));

			l2Item.classList.add('active');
			const restGroup = subMenu.querySelector('[data-group="' + target + '"]');
			if (restGroup) restGroup.classList.add('active');
			return restGroup;
		}

		overviewList.addEventListener('mouseover', function (e) {
			const l2Item = e.target.closest('.l2-item');
			if (!l2Item) return;
			activateL2Item(l2Item);
		});

		// Keyboard: tabbing through .l2-item links does not change which
		// rest-group is shown (only the mouse hover does that above) —
		// Enter on a l2-item activates its rest-group and moves focus
		// into it, so tabbing continues there.
		overviewList.querySelectorAll('.l2-item > a').forEach(function (link) {
			link.addEventListener('keydown', function (e) {
				if (e.key !== 'Enter') return;
				e.preventDefault();
				const l2Item = link.closest('.l2-item');
				const restGroup = activateL2Item(l2Item);
				const firstFocusable = restGroup ? restGroup.querySelector('a, button') : null;
				if (firstFocusable) firstFocusable.focus();
			});
		});

		// Tabbing past the last VISIBLE .l2-item without having opened
		// its rest-group (i.e. plain Tab, not Enter) would otherwise
		// fall into whichever rest-group happens to be active (e.g.
		// still the first one, from the default state) — content
		// unrelated to where focus actually is. Skip straight to the
		// next top-level menu item in .site-menu instead. Some l2-items
		// (e.g. "related", shown as a splide gallery elsewhere) are
		// display:none, so "last" is worked out fresh each time rather
		// than off a fixed NodeList.
		overviewList.addEventListener('keydown', function (e) {
			if (e.key !== 'Tab' || e.shiftKey) return;
			const l2Item = e.target.closest('.l2-item');
			if (!l2Item || e.target.tagName !== 'A') return;

			let next = l2Item.nextElementSibling;
			while (next && (!next.classList.contains('l2-item') || getComputedStyle(next).display === 'none')) {
				next = next.nextElementSibling;
			}
			if (next) return; // there's a next visible l2-item — let Tab go there normally

			const menuItem = subMenu.closest('.menu-item-has-children');
			const nextMenuItem = menuItem ? menuItem.nextElementSibling : null;
			const nextLink = nextMenuItem ? nextMenuItem.querySelector(':scope > a') : null;
			if (nextLink) {
				e.preventDefault();
				nextLink.focus();
			}
		});

		// Tabbing out of the last link in the active rest-group would
		// otherwise fall through to the next top-level menu item (since
		// in the DOM all rest-groups come after all l2-items). Instead,
		// send focus back into the overview list, to the l2-item right
		// after the currently active one — the rest-group is only
		// "in between" conceptually, not in DOM order. If the active
		// l2-item is the last one, there's nothing to jump back to, so
		// let Tab proceed normally out of the sub-menu.
		subMenu.addEventListener('keydown', function (e) {
			if (e.key !== 'Tab' || e.shiftKey) return;

			const activeGroup = subMenu.querySelector('.rest-group.active');
			if (!activeGroup) return;

			const focusables = activeGroup.querySelectorAll('a, button');
			if (!focusables.length || document.activeElement !== focusables[focusables.length - 1]) return;

			const activeL2 = subMenu.querySelector('.l2-item.active');
			let nextL2 = activeL2 ? activeL2.nextElementSibling : null;
			while (nextL2 && (!nextL2.classList.contains('l2-item') || getComputedStyle(nextL2).display === 'none')) {
				nextL2 = nextL2.nextElementSibling;
			}
			if (nextL2) {
				const link = nextL2.querySelector(':scope > a');
				if (link) {
					e.preventDefault();
					link.focus();
				}
			}
		});

		subMenu.addEventListener('mouseleave', function () {
			const l2Items    = subMenu.querySelectorAll('.l2-item');
			const restGroups = subMenu.querySelectorAll('.rest-group');

			l2Items.forEach(el => el.classList.remove('active'));
			restGroups.forEach(el => el.classList.remove('active'));

			if (l2Items[0]) l2Items[0].classList.add('active');

			const firstTarget = l2Items[0]?.dataset.target;
			if (firstTarget) {
				const firstGroup = subMenu.querySelector('[data-group="' + firstTarget + '"]');
				if (firstGroup) firstGroup.classList.add('active');
			}
		});
	});

	// WalkerMenuFlyin — öppna/stäng sub-menu med icon-plus / icon-remove.
	// Both icons are always in the DOM (CSS shows only one at a time), so
	// each is tabbable via tabindex="0" and the hidden one is naturally
	// skipped by the browser. Since they're <i> elements, not real
	// buttons, Enter/Space needs explicit handling — a click doesn't
	// fire on its own.
	function bindFlyinToggle(btn, activate) {
		function run(e) {
			if (e.type === 'keydown') {
				if (e.key !== 'Enter' && e.key !== ' ') return;
				e.preventDefault();
			}
			const menuItem = btn.closest('.menu-item-has-children');
			const group    = menuItem?.querySelector(':scope > .group');
			const subMenu  = menuItem?.querySelector(':scope > .sub-menu');
			if (activate) {
				if (subMenu) subMenu.classList.add('open');
				if (group) group.classList.remove('inactive');
				if (menuItem) menuItem.classList.add('active');
			} else {
				if (subMenu) subMenu.classList.remove('open');
				if (group) group.classList.add('inactive');
				if (menuItem) menuItem.classList.remove('active');
			}
			// Focus follows to whichever icon is now visible, so the
			// toggle can immediately be reversed or tabbing continues
			// naturally into the (now open) sub-menu right after it.
			const otherIcon = group?.querySelector(activate ? ':scope > .icon-remove' : ':scope > .icon-plus');
			if (otherIcon) otherIcon.focus();
		}
		btn.addEventListener('click', run);
		btn.addEventListener('keydown', run);
	}

	document.querySelectorAll('#flyout_menu .menu-item-has-children .group .icon-plus').forEach(function (btn) {
		bindFlyinToggle(btn, true);
	});

	document.querySelectorAll('#flyout_menu .menu-item-has-children .group .icon-remove').forEach(function (btn) {
		bindFlyinToggle(btn, false);
	});

	// Lägg open på current-menu-item / current-page-ancestor / current_page_item, inactive på alla övriga
	document.querySelectorAll('#flyout_menu .menu-item-has-children').forEach(function (menuItem) {
		const group   = menuItem.querySelector(':scope > .group');
		const subMenu = menuItem.querySelector(':scope > .sub-menu');
		const isActive = menuItem.classList.contains('current-menu-item')
			|| menuItem.classList.contains('current-page-ancestor')
			|| menuItem.classList.contains('current_page_item');
		if (isActive) {
			menuItem.classList.add('open');
			if (subMenu) subMenu.classList.add('open');
		} else {
			if (group) group.classList.add('inactive');
		}
	});
});

//# sourceMappingURL=menu-header.js.map
